import { render, staticRenderFns } from "./playerContract.vue?vue&type=template&id=2a74c600&scoped=true&"
import script from "./playerContract.vue?vue&type=script&lang=js&"
export * from "./playerContract.vue?vue&type=script&lang=js&"
import style0 from "./playerContract.vue?vue&type=style&index=0&id=2a74c600&scoped=true&lang=css&"
import style1 from "./playerContract.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74c600",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
